export default __webpack_public_path__ + "static/media/avatarD1.69e8e84b.png";